import axios from 'axios';

export const createContactUs = async (title, email, company, name, phone, message) => {
    console.log('email.service:createContactUs', title, email, company, name, phone, message);

    const url = `/v1/email/contact-us`;
    const data = {
        title, email, company, name, phone, message
    };
    return axios.post(url, data)
        .then(result => {
            const response = result.data;
            return response;
        }).catch(errorHandler)
}

const errorHandler = err => {
    console.error(err)
    return false;
}